<template>
  <div class="hf-box">
    <div class="hf-content">
      <div class="hf-video-wrap">
        <video 
          ref="videoPlayer"
          class="hf-video"
          :src="videoUrl"
          @timeupdate="onTimeUpdate"
          @loadedmetadata="onLoadedMetadata"
          @ended="onEnded"
        ></video>
        <div class="hf-controls">
          <div class="hf-controls-btn" @click="togglePlay">
            <span v-if="isPlaying">&#10074;&#10074;</span>
            <span v-else>&#9654;</span>
          </div>
          <span class="hf-controls-time">{{formatTime(currentTime)}}</span>
          <div class="hf-controls-progress" ref="progressBar" @click="seekVideo" @mousedown="onProgressMouseDown">
        <div class="hf-controls-progress-bg"></div>
        <div class="hf-controls-progress-fill" :style="{ width: progress + '%' }"></div>
        <div class="hf-controls-progress-dot" :style="{ left: progress + '%' }"></div>
      </div>
          <span class="hf-controls-time">{{formatTime(duration)}}</span>
          <div class="hf-controls-speed" @click="toggleSpeed">{{$t('all.beisu')}} x{{playbackRate}}</div>
        </div>
      </div>
    </div>
    <div class="hf-sidebar">
      <div class="hf-sidebar-title">{{$t('all.zhibojilu')}}</div>
      <div class="hf-sidebar-list">
        <div 
          :class="currentIndex === index ? 'hf-sidebar-item-active' : 'hf-sidebar-item'" 
          v-for="(item, index) in replayList" 
          :key="index"
          @click="handleSwitchReplay(index)"
        >
          <div class="hf-sidebar-item-cover" :style="{ backgroundImage: 'url(' + item.backgroundUrl + ')' }"></div>
          <div class="hf-sidebar-item-info">
            <span class="hf-sidebar-item-info-title">{{item.name}}</span>
            <span class="hf-sidebar-item-info-tag">{{item.categoryName}}</span>
            <span class="hf-sidebar-item-info-time">{{item.liveStartTime}} - {{item.liveEndTime}}</span>
          </div>
          <img class="hf-sidebar-item-hot" v-if="item.isHot" src="../../../assets/image/shanchu_18@2x.png" alt="" />
          <img class="hf-sidebar-item-del" src="../../../assets/image/shanchu_18@2x.png" alt="" @click.stop="handleDelete(item, index)" v-if="!$route.query.viewUserId || $route.query.viewUserId == $store.state.userId"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserLiveRecordList, delLiveRecord } from "@/api/zhibo";
export default {
  data() {
    return {
      videoUrl: 'https://unishow-live-1383640469.cos.ap-hongkong.myqcloud.com/webStorage/web_17820917238043760.mp4',
      videoName: '',
      videoPeriod: '',
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      progress: 0,
      playbackRate: 1,
      speeds: [1, 1.5, 2, 0.5],
      speedIndex: 0,
      replayList: [],
      currentIndex: 0,
      isDragging: false
    };
  },
  mounted() {
    // this.videoUrl = this.$route.query.url || '';
    // this.videoName = this.$route.query.name || '';
    this.videoPeriod = this.$route.query.period || '';
    this.getReplayList();
    document.addEventListener('mousemove', this.onProgressMouseMove);
    document.addEventListener('mouseup', this.onProgressMouseUp);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onProgressMouseMove);
    document.removeEventListener('mouseup', this.onProgressMouseUp);
  },
  methods: {
    async getReplayList() {
      try {
        const response = await getUserLiveRecordList({ page: 1, size: 20, viewUserId:this.$route.query.viewUserId?this.$route.query.viewUserId: this.$store.state.userId,queryReplay:1 });
        this.replayList = response.rows;
		this.videoUrl = this.replayList[0].replayUrl
      } catch (error) {
        console.error("获取回放列表失败:", error);
        this.replayList = [];
      }
    },
    togglePlay() {
      const video = this.$refs.videoPlayer;
      if (this.isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      this.isPlaying = !this.isPlaying;
    },
    onTimeUpdate() {
      if (this.isDragging) return;
      const video = this.$refs.videoPlayer;
      this.currentTime = video.currentTime;
      this.progress = this.duration > 0 ? (this.currentTime / this.duration) * 100 : 0;
    },
    onLoadedMetadata() {
      this.duration = this.$refs.videoPlayer.duration;
    },
    onEnded() {
      this.isPlaying = false;
      this.progress = 0;
      this.currentTime = 0;
    },
    seekVideo(e) {
      if (this.isDragging) return;
      const bar = this.$refs.progressBar;
      const rect = bar.getBoundingClientRect();
      const percent = (e.clientX - rect.left) / rect.width;
      this.updateProgress(percent);
    },
    onProgressMouseDown(e) {
      this.isDragging = true;
      const bar = this.$refs.progressBar;
      const rect = bar.getBoundingClientRect();
      const percent = (e.clientX - rect.left) / rect.width;
      this.updateProgress(percent);
    },
    onProgressMouseMove(e) {
      if (!this.isDragging) return;
      const bar = this.$refs.progressBar;
      const rect = bar.getBoundingClientRect();
      let percent = (e.clientX - rect.left) / rect.width;
      percent = Math.max(0, Math.min(1, percent));
      this.updateProgress(percent);
    },
    onProgressMouseUp() {
      if (this.isDragging) {
        this.isDragging = false;
      }
    },
    updateProgress(percent) {
      this.progress = percent * 100;
      this.currentTime = percent * this.duration;
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.currentTime = this.currentTime;
      }
    },
    toggleSpeed() {
      this.speedIndex = (this.speedIndex + 1) % this.speeds.length;
      this.playbackRate = this.speeds[this.speedIndex];
      this.$refs.videoPlayer.playbackRate = this.playbackRate;
    },
    formatTime(seconds) {
      if (!seconds || isNaN(seconds)) return '00:00';
      const min = Math.floor(seconds / 60);
      const sec = Math.floor(seconds % 60);
      return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
    },
    handleSwitchReplay(index) {
      this.currentIndex = index;
      const item = this.replayList[index];
      this.videoUrl = item.replayUrl;
      this.videoName = item.name;
      this.videoPeriod = item.period;
      this.isPlaying = false;
      this.currentTime = 0;
      this.progress = 0;
      this.$nextTick(() => {
        this.$refs.videoPlayer.load();
        this.$refs.videoPlayer.play().then(() => {
          this.isPlaying = true;
        }).catch(err => {
          console.warn('自动播放失败:', err);
        });
      });
    },
    handleDelete(item, index) {
      const id = item.id || item.liveId;
      if (!id) {
        this.$message.error(this.$t('all.qingshurushuju'));
        return;
      }
      this.$confirm(this.$t('all.confirmDelete') || '确认删除该直播记录？').then(() => {
        delLiveRecord({ id }).then(res => {
          this.$message.success(res.msg || this.$t('all.shanchuchenggong') || '删除成功');
          this.replayList.splice(index, 1);
          if (this.currentIndex === index && this.replayList.length > 0) {
            this.currentIndex = Math.min(index, this.replayList.length - 1);
            this.handleSwitchReplay(this.currentIndex);
          } else if (this.replayList.length === 0) {
            this.videoUrl = '';
          }
        }).catch(err => {
          this.$message.error(err.message || '删除失败');
        });
      }).catch(() => {});
    }
  }
};
</script>

<style scoped lang="scss">
@import "./huifang.css";
</style>



// WEBPACK FOOTER //
// huifang.vue?1f661423